<template>
  <div class="flex flex-col">
    <eezee-nav />
    <div
      class="flex flex-col content-center justify-center items-center text-center py-40 font-bold text-2xl z-10" :style="this.isEzzezzTheme ? 'color: #4f4f4f' : 'color: #001136'">
      <img
        src="../../assets/green-checkmark.gif"
        alt="success"
        class="h-24 w-24" />
      <p>{{ $t('Congratulations') }}</p>
      <p>{{ $t('ActivatedSuccessfully') }}</p>
    </div>
    <img
        v-if="!isEzzezzTheme"
        src="../../assets/RedBullPatternWave.svg"
        alt="RedBull Pttern"
        class="h-full absolute w-full opacity-60"
        style="top: 8%"
    />
  </div>
</template>

<script>
import EezeeNav from '@/components/eezee/EezeeNav.vue'

export default {
  name: 'SuccessEezee',
  components: { EezeeNav },
  data() {
    return {
      isEzzezzTheme: this.$route.path.startsWith('/eezee')
    }
  }
}
</script>

<style scoped></style>
